import { urqlGql } from '@pypestream/api-services/urql';
import {
  MetabaseDataset,
  MetabaseFoldersByDataset,
  METABASE_DATASETS,
} from './metabase-access.types';

export const fetchMetabaseFolders = async (
  projectId: string
): Promise<MetabaseFoldersByDataset> => {
  const { data, error } = await urqlGql.getMetabaseFolders({ projectId });

  if (error) {
    throw error;
  }

  const groupsByDataset: MetabaseFoldersByDataset = { live: [], sandbox: [] };

  (data?.admin_?.getMetabaseFolders?.datasets ?? []).forEach((ds) => {
    if (!METABASE_DATASETS.includes(ds.dataset as MetabaseDataset)) {
      return;
    }
    groupsByDataset[ds.dataset as MetabaseDataset] = ds.groups
      .filter((group) => group.id !== '' && Number.isInteger(Number(group.id)))
      .map((group) => ({
        id: group.id,
        name: group.name,
        dashboardCount: group.dashboardCount,
      }));
  });

  return groupsByDataset;
};
